import * as React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const SquareOutlinedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width={22} height={22} viewBox="0 0 22 22" fill="none" {...props}>
      <rect
        width={23 - 2 * 2}
        height={23 - 2 * 2}
        x={2}
        y={2}
        fill="none"
        stroke="#BF295C"
        strokeWidth="1px"
        rx={4}
      />
    </SvgIcon>
  );
};
